module.exports = __webpack_public_path__ + "img/empty.595ff321.png";